import type { CustomCellEditorProps } from 'ag-grid-react';

import { useFormattedPercentInput } from '@mint-lib/formatting-hooks';
import { Input } from '@mint-lib/tw-components';

import { useStartFromEventKey } from '../hooks/useStartFromEventKey.js';

export interface PercentEditorProps extends CustomCellEditorProps {
  maxDecimals?: number;
  min?: number;
}

export const PercentEditor = (props: PercentEditorProps) => {
  const { onValueChange, value, eventKey, maxDecimals, min } = props;

  const startValue = useStartFromEventKey(eventKey, value, onValueChange);

  const inputProps = useFormattedPercentInput({
    onChange: onValueChange,
    value: startValue === '' ? null : startValue,
    size: 'small',
    autoFocus: true,
    maxDecimals,
    restFormatProps: { min },
  });

  return (
    <Input
      className="w-full border-none focus:outline-none"
      aria-label="percent-editor"
      data-dd-action-name="Grid cell: edit percentage"
      {...inputProps}
    />
  );
};
